/* Kontakt- und Gutscheinformular — Verhalten aus der Vorlage vom 31.07.
   Anliegen wechselt den Platzhalter, Betragsstufe wechselt die Vorschaukarte,
   der Versandtermin wird in ein Datum übersetzt. */
(function () {
  /* ---------- Aufklappmenü (Versandtermin) ---------- */
  function bindSelect(wrap) {
    if (!wrap || wrap.dataset.waBound === '1') return null;
    wrap.dataset.waBound = '1';

    var trigger = wrap.querySelector('[data-wa-facet-trigger]');
    var panel = wrap.querySelector('[data-wa-facet-panel]');
    var caret = wrap.querySelector('[data-wa-facet-caret]');
    var value = wrap.querySelector('[data-wa-facet-value]');
    if (!trigger || !panel) return null;

    function close() {
      panel.hidden = true;
      wrap.removeAttribute('data-open');
      if (caret) caret.textContent = '+';
    }

    function open() {
      panel.hidden = false;
      wrap.setAttribute('data-open', '1');
      if (caret) caret.textContent = '−';
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) open(); else close();
    });

    document.addEventListener('click', close);

    return { close: close, value: value, panel: panel };
  }

  /* ---------- Kontakt: Anliegen ---------- */
  (function () {
    var root = document.querySelector('[data-wa-contact]');
    if (!root) return;

    var target = root.querySelector('[data-wa-topic-target]');
    var hidden = root.querySelector('[data-wa-topic-value]');

    root.querySelectorAll('[data-wa-topic]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-wa-topic]').forEach(function (b) {
          b.removeAttribute('data-active');
        });
        btn.setAttribute('data-active', '1');
        if (hidden) hidden.value = btn.textContent.trim();
        if (target) target.placeholder = btn.dataset.placeholder || '';
      });
    });
  })();

  /* ---------- Gutschein: Betrag, Karte, Termin ---------- */
  (function () {
    var root = document.querySelector('[data-wa-voucher]');
    if (!root) return;

    var input = root.querySelector('[data-wa-tier-input]');
    var cardImage = root.querySelector('[data-wa-card-image]');
    var cardAmount = root.querySelector('[data-wa-card-amount]');

    root.querySelectorAll('[data-wa-tier]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-wa-tier]').forEach(function (b) {
          b.removeAttribute('data-active');
        });
        btn.setAttribute('data-active', '1');

        if (input) input.value = btn.dataset.variant;
        if (cardAmount) cardAmount.textContent = btn.dataset.amount;
        if (cardImage && btn.dataset.image) {
          cardImage.removeAttribute('srcset');
          cardImage.src = btn.dataset.image;
        }
      });
    });

    var dateWrap = root.querySelector('[data-wa-facet="senddate"]');
    var select = bindSelect(dateWrap);
    var dateInput = root.querySelector('[data-wa-date-input]');

    function isoFor(option) {
      var fixed = (option.dataset.fixed || '').trim();
      if (fixed) return fixed;

      var days = Number(option.dataset.days || 0);
      if (!days) return '';

      var d = new Date();
      d.setDate(d.getDate() + days);
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return d.getFullYear() + '-' + m + '-' + day;
    }

    root.querySelectorAll('[data-wa-date-option]').forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.stopPropagation();
        root.querySelectorAll('[data-wa-date-option]').forEach(function (o) {
          o.removeAttribute('data-selected');
        });
        option.setAttribute('data-selected', '1');
        if (select && select.value) select.value.textContent = option.textContent.trim();
        if (dateInput) dateInput.value = isoFor(option);
        if (select) select.close();
      });
    });
  })();
})();
